import React from 'react';
import Container from '../../../containers/master/scholastics/showScholasticContainer';

export default function () {
  return (
    <Container />
  );
}
